import { createSelector } from '@reduxjs/toolkit';
import { createSelectorBindings } from '@ff-os/pdp-shared-redux/slices/externalUploadersSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsExternalUploadPayload } from '@ff-scene-plugins/photo-prints-redux/types/PhotoPrintsExternalUploader';

const selectors = createSelectorBindings<PhotoPrintsExternalUploadPayload>();

export const selectAllExternalUploaders = selectors.selectAll;

export const selectExternalUploaderByGroupId = createSelector([
    selectAllExternalUploaders,
    (_: PhotoPrintsPdpState, groupId: string) => groupId
], (externalUploaders, groupId) => {
    return externalUploaders
        .filter(eu => eu.expiresOn > Date.now())
        .find(eu => eu.settings.payload.groupId === groupId);
});